<template>
  <div class="landing-page">
    <div class="iframe-container">
      <img
        v-if="!clicked_video"
        src="@/assets/gungroup-video-image.jpg"
        class="video picture"
        @click="clicked_video = true"
      >
      <iframe
        v-else
        src="https://www.youtube.com/embed/pQe9y2e63ig"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video"
      />
    </div>

    <div class="outlined-card">
      <div class="header">
        <h1 class="mt">
          Welcome to GUNGROUP.COM
        </h1>
      </div>
      <p>
        Where you can
        <span>BUY</span>,
        <span>SELL</span>, and
        <span>TRADE</span>
        firearms within your community.
      </p>

      <!-- facebook and google login/register -->
      <p
        v-if="errors"
        class="alert alert-danger"
      >
        {{ errors[0] }}
      </p>

      <div class="forms mt">
        <div />
        <facebook-login @error="setErrors" />
        <div class="mt" />
        <g-g-google-login />
        <div />
      </div>

      <hr>

      <!-- forms login/register -->
      <div class="forms">
        <h3 class="form-title">
          Register
        </h3>
        <registration-form :landing-page="true" />
        <div class="or">
          or
        </div>
        <h3 class="form-title mt">
          <hr class="mt">
          Login
        </h3>
        <login-form :landing-page="true" />
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';
import FacebookLogin from '@/components/FacebookLogin.vue';
import GGGoogleLogin from '@/components/GGGoogleLogin.vue';
import RegistrationForm from '@/components/RegistrationForm.vue';

export default {
  name: 'LandingPage',
  components: {
    RegistrationForm,
    GGGoogleLogin,
    FacebookLogin,
    LoginForm,
  },
  data() {
    return {
      clicked_video: false,
      errors: null,
    };
  },
  methods: {
    setErrors(errors) {
      this.errors = errors;
    },
  },
};
</script>

<style lang="scss" scoped>
  .iframe-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }
  .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
  }
  .picture:hover {
    filter: brightness(80%);
  }
  .outlined-card {
    border: 1px solid grey;
    border-radius: .4rem;

    margin: 50px 0px;
    padding: 15px;

    .header {
      // center h1
      max-width: 460px;
      margin: 0 auto;

      h1 {
        text-align: center;
        margin-top: -35px;

        background-color: var(--blue-lightest);
      }
    }

    p {
      text-align: center;

      span {
        color: var(--blue-dark);
        font-weight: 600;
        letter-spacing: 1px;
      }
    }

    .forms {
      display: flex;
      justify-content: space-around;

      .form-title {
        display: none;
      }

      .or {
        align-self: center;
      }
    }
  }
  @media (max-width: 650px) {
    .outlined-card {
      border: none;
      padding: 3px;
    }

    .forms {
      display: block !important;

      .form-title {
        display: block !important;
        color: var(--blue-dark);
        font-weight: 600;
        letter-spacing: 1px;
      }

      .or {
        display: none;
      }
    }
  }
</style>
